<template>
    <div
        style="position: relative; height: 100%;"
    >
        <div
            class="header"
            style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;padding-top: var(--mobile-padding-top, 25px);display: flex;"
        >
            <div>
                <v-icon
                    size="64"
                >
                    mdi-seal-variant
                </v-icon>
            </div>
            <div>
                <h1>
                    Certified Message
                </h1>
                <span style="font-weight: normal;">Your certified message from <span class="legalFoot"></span></span>
            </div>
        </div>
        <v-layout
            row
            wrap
        >
            <v-flex
                xs12
                md6
                style="padding: 25px;"
                v-if="loading"
            >
                <v-progress-circular
                    indeterminate
                    style="padding: 10px;"
                />
            </v-flex>
            <v-expand-transition>
                <v-flex
                    xs12
                    md6
                    style="padding: 25px;"
                    v-if="!loading"
                >
                    <h2>{{ message.subject }}</h2>
                    <div
                        style="background: #fff;border-radius: 10px !important;padding: 10px;"
                    >
                        <div
                            v-html="message.message"
                        />
                    </div>
                    <span style="color: rgba(0,0,0,0.5);font-size: 12px;">sent {{convertToCalRef(message.sent_at)}}</span>
                    <v-btn
                        color="primary"
                        style="float: right;"
                        :to="{'name': 'Messages'}"
                    >
                        Back to All Messages
                    </v-btn>
                </v-flex>
            </v-expand-transition>
        </v-layout>
    </div>
</template>

<script>
import api from '@/api'

export default{
    name: 'CertifiedMessage',
    data () {
        return {
            loading: true,
            message: null,
            fetchingLocation: false
        }
    },
    created () {
        this.getCertifiedMessage()
    },
    methods: {
        getCertifiedMessage () {
            api.users.client_messages.read(this.$route.params.id)
                .then((response) => {
                    this.message = response.data
                    this.loading = false
                })
        }
    },
}
</script>

<style scoped>
    .header {
        position: static;
        top:0 !important;
        right:0;
        left:0;
    }
    .flex-card {
        padding: 10px;
    }
    .certifiedmessage {
        position: relative;
        margin-top: 0;
        padding: 15px;
        max-height: calc(100vh - 71px);
        max-width: 500;
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 5px;
    }
    .message-info {

    }
</style>